const GROUP_THRESHOLD_MINUTES = 5;

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export function isSameDay(a, b) {
  if (!a || !b) return false;
  const da = new Date(a);
  const db = new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
}

export function shouldGroup(prev, current, thresholdMinutes = GROUP_THRESHOLD_MINUTES) {
  if (!prev || !current) return false;
  const prevSender = prev.sender?.id;
  const currSender = current.sender?.id;
  if (prevSender == null || currSender == null || prevSender !== currSender) return false;

  const prevTime = new Date(prev.created_at).getTime();
  const currTime = new Date(current.created_at).getTime();
  const diffMinutes = Math.abs(currTime - prevTime) / 1000 / 60;
  return diffMinutes <= thresholdMinutes;
}

export function formatDateLabel(timestamp, now = new Date()) {
  const date = new Date(timestamp);
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const diffDays = Math.floor((startOfDay(now) - startOfDay(date)) / ONE_DAY_MS);

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) {
    return date.toLocaleDateString([], { weekday: 'short' });
  }
  return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

export function formatTimeLabel(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function buildMessageTimeline(messages, currentUserId, now = new Date()) {
  return messages.map((message, index) => {
    const prev = messages[index - 1];
    const next = messages[index + 1];

    const inSameDayAsPrev = prev ? isSameDay(prev.created_at, message.created_at) : false;
    const inSameDayAsNext = next ? isSameDay(message.created_at, next.created_at) : false;

    const groupedWithPrev = shouldGroup(prev, message);
    const groupedWithNext = shouldGroup(message, next);

    return {
      message,
      meta: {
        isMine: Number(message.sender?.id) === Number(currentUserId),
        showDateDivider: !prev || !inSameDayAsPrev,
        dateLabel: formatDateLabel(message.created_at, now),
        isGroupStart: !groupedWithPrev,
        isGroupEnd: !groupedWithNext,
        showTimestamp: !groupedWithNext,
        lastInDay: !next || !inSameDayAsNext,
      },
    };
  });
}

const messageTimelineUtils = {
  buildMessageTimeline,
  formatDateLabel,
  formatTimeLabel,
  isSameDay,
  shouldGroup,
};

export default messageTimelineUtils;


